import { RecipientSelectorModal } from './RecipientSelectorModal'

type Props = {
  show: boolean
  onHide: () => void
  onSubmit: (payload: { contactId: string }[]) => Promise<void>
  onSync?: (selectedContactIds: string[]) => Promise<void>
  loading?: boolean
  campaignName?: string
  campaignId?: string
  initialSelectedIds?: string[]
  onBulkAdded?: () => void
}

export const AddTargetModal = ({
  show,
  onHide,
  onSubmit,
  onSync,
  loading,
  campaignId,
  initialSelectedIds = [],
  onBulkAdded,
}: Props) => {
  const handleSave = async (selectedIds: string[]) => {
    if (onSync) {
      await onSync(selectedIds)
    } else {
      const targets = selectedIds.map((id) => ({ contactId: id }))
      await onSubmit(targets)
      onHide()
    }
  }

  return (
    <RecipientSelectorModal
      show={show}
      onHide={onHide}
      onSave={handleSave}
      initialSelectedIds={initialSelectedIds}
      confirmLabel={loading ? 'Saving...' : 'Save targets'}
      campaignId={campaignId}
      onBulkAdded={onBulkAdded}
    />
  )
}
